<script>
  import { csvFormat } from "d3";
  import { onMount } from "svelte";

  let mounted = false;

  export let data;
  export let title;

  let hiddenElement;
  let url;

  const filename = title;

  $: if (mounted) {
    let formatted = csvFormat(data);
    let blob = new Blob([formatted], { type: "text/csv;charset=utf-8;" });
    url = window.URL.createObjectURL(blob);
  }

  const download = () => hiddenElement.click();

  onMount(() => {
    mounted = true;
  });
</script>

<button on:click="{download}">Download the data</button>
<a href="{url}" download="{filename}" hidden bind:this="{hiddenElement}"
  >Download the data</a
>

<style>
  button {
    appearance: none;
    user-select: none;
    line-height: 1;
    margin: 0 auto;
    padding: 0.5em;
    border-radius: 0;
    outline: none;
    cursor: pointer;
    font-family: inherit;
    font-size: 14px;
    display: block;
    background-color: var(--fg);
    color: var(--bg);
  }
</style>
